import { DataTestId } from '../../../../core/types/data-props.js';
import { StylingProps } from '../../../../core/types/styling-props.js';
import { WithChildren } from '../../../../core/types/with-children.js';
import { InternalBaseItem as BaseItem } from '../form-field-messages/FormFieldMessageBaseItem.js';

/**
 * @public
 */
export interface HintProps extends WithChildren, StylingProps, DataTestId {
  /**
   * Whether the connected input is currently disabled.
   * @defaultValue false
   */
  disabled?: boolean;
  /** Id to link the hint to its corresponding element. */
  id?: string;
}

/**
 * Renders a hint message if given, otherwise renders nothing.
 * @public
 */
export const Hint = (props: HintProps) => {
  const { children, ...remainingProps }: HintProps = props;

  return children ? (
    <BaseItem variant="hint" {...remainingProps}>
      {children}
    </BaseItem>
  ) : null;
};

Hint.displayName = 'Hint';
